var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationLaptopMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 359,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "27.795%",
    x2: "100%",
    y2: "72.205%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F71",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E55",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-35.1%",
    y: "-60.8%",
    width: "170.1%",
    height: "221.7%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.421821759 0 0 0 0 0.554338424 0 0 0 0 0.893710371 0 0 0 0.243444056 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 237,
    height: 157.94,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0h321.953a3 3 0 013 3v4.602H0V3a3 3 0 013-3z",
    id: "e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(86 17)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2D2E40",
    opacity: 0.08,
    transform: "matrix(1 0 0 -1 0 329)",
    x: 52,
    y: 53,
    width: 223,
    height: 223,
    rx: 111.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.5,
    transform: "matrix(1 0 0 -1 0 326)",
    x: 37.5,
    y: 37.5,
    width: 251,
    height: 251,
    rx: 125.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.25,
    transform: "matrix(1 0 0 -1 0 326)",
    x: 0.5,
    y: 0.5,
    width: 325,
    height: 325,
    rx: 162.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(85 85)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#535353",
    fillRule: "nonzero",
    x: 39,
    y: 7,
    width: 252,
    height: 173,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1D1D25",
    fillRule: "nonzero",
    x: 40,
    y: 9,
    width: 250,
    height: 170,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F9F6F6",
    fillRule: "nonzero",
    mask: "url(#d)",
    x: -0.152,
    y: 28.352,
    width: 237,
    height: 129.709,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.478 17.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 49.951,
    height: 120.635,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 58.453,
    width: 111.592,
    height: 120.635,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E7E7E7",
    x: 63.235,
    y: 6.405,
    width: 102.027,
    height: 28.291,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E7E7E7",
    x: 63.235,
    y: 40.568,
    width: 30.289,
    height: 28.291,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E7E7E7",
    x: 100.964,
    y: 40.568,
    width: 64.298,
    height: 28.291,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164)",
    fill: "#4A5166",
    fillRule: "nonzero",
    opacity: 0.098
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.12,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.56,
    width: 1.44,
    height: 1,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 178)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#52526F",
    fillRule: "nonzero",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2F2F47",
    fillRule: "nonzero",
    mask: "url(#f)",
    x: 137.193,
    y: -18.626,
    width: 53.567,
    height: 23.187,
    rx: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 186h328a3 3 0 01-3 3H3a3 3 0 01-3-3z",
    fill: "#393A56",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLaptopMobile);
export default __webpack_public_path__ + "static/media/illustration-laptop-mobile.fe1ec0f05da01bb067fa78fca0b79d76.svg";
export { ForwardRef as ReactComponent };